/**
 * The Maintenance settings route. Shared by the route's `beforeLoad` and the page's `<ModuleGate>`,
 * which both look its owning module up in the registry (`moduleAreaForPath`) rather than naming it —
 * so moving this screen to another module is a registry edit, not a hunt for string literals.
 */
export const MAINTENANCE_SETTINGS_PATH = '/settings/maintenance';
